import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'sk_SK',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'a890a7d4-f6e9-4833-9f5b-2a6777796079',
  ''
);
